<mat-toolbar color="primary" class="test">   
  <mat-toolbar-row>
    <button *ngIf="authentication && toolbarButton === 1" mat-icon-button (click)="menuToggle()" [matTooltip]="'MENU-BUTTON' | translate">
      <mat-icon>menu</mat-icon>
    </button>
    <button *ngIf="toolbarButton === 2" mat-icon-button (click)="back()" [matTooltip]="'BACK-BUTTON' | translate">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <button *ngIf="toolbarButton === 3" mat-icon-button (click)="home()" [matTooltip]="'HOME-BUTTON' | translate">
      <mat-icon>home</mat-icon>
    </button>

    <h1 translate class="toolbar-title" *ngIf="authentication">{{ title }}</h1>

    <div fxFlex="5"></div>
    <button mat-icon-button [matTooltip]="'Homepage' | translate" (click)="home()" *ngIf="authentication && !isMobile">
      <mat-icon svgIcon="home"></mat-icon>
    </button> 

    <div fxFlex="5"></div>
    <ng-template [ngIf]="authentication && !isMobile">

 

      <button mat-icon-button [matTooltip]="'Anagrafica' | translate" (click)="goToAnagrafica()">
        <mat-icon svgIcon="account_circle"></mat-icon>
      </button>     
      
      <ng-template [ngIf]="user.Anagrafica.ruolo==2 || user.Anagrafica.ruolo==1">
      <button mat-icon-button [matTooltip]="'Gestione Clienti' | translate" (click)="goToUsers()">
        <mat-icon svgIcon="group"></mat-icon>
      </button>
    </ng-template>
      
      <button mat-icon-button [matTooltip]="'Pesate' | translate" (click)="goToPesate()">
        <mat-icon svgIcon="trending_down"></mat-icon>
      </button>

      <button mat-icon-button [matTooltip]="'Macros' | translate" (click)="goToMacros()">
        <mat-icon svgIcon="food-apple"></mat-icon>
      </button>

      <button mat-icon-button [matTooltip]="'Report' | translate" (click)="goToReport()">
        <mat-icon svgIcon="art_track"></mat-icon>
      </button>

      <button mat-icon-button [matTooltip]="'Modulistica' | translate" (click)="goToModulistica()">
        <mat-icon svgIcon="cloud_download"></mat-icon>
      </button>

       <button mat-icon-button [matTooltip]="'BMR' | translate" (click)="goToBmr()">
          <mat-icon svgIcon="calculate"></mat-icon>
      </button>

        <button mat-icon-button [matTooltip]="'BodyFat' | translate" (click)="goToBf()">
        <mat-icon svgIcon="caliper"></mat-icon>
        </button>

        <button mat-icon-button [matTooltip]="'Bmi' | translate" (click)="goToBmi()">
          <mat-icon svgIcon="monitor_weight"></mat-icon>
          </button>

          <ng-template [ngIf]="user.Anagrafica.ruolo==2 || user.Anagrafica.ruolo==1">
          <button mat-icon-button [matTooltip]="'Piano Alimentare' | translate" (click)="goToMacroProgressioni()">
            <mat-icon svgIcon="food-apple"></mat-icon>
            </button>
          </ng-template>

  </ng-template>
   
    <div fxFlex></div>

    <ng-template [ngIf]="authentication">

      <button mat-icon-button [matTooltip]="'LOGOUT' | translate" (click)="logoutUser()">
          <mat-icon svgIcon="exit_to_app"></mat-icon>
      </button>
  
  </ng-template>

    <ng-content></ng-content>
  </mat-toolbar-row>
</mat-toolbar>
